export default [{
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import('../views/login.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () =>
      import('../views/404.vue')
  },
  {
    path: '/403',
    name: '403',
    component: () =>
      import('../views/403.vue')
  }
]
